import Video from '.';
import { VIDEO_LABELS } from '../../constants';

function initialiseVideos() {
	const videos = document.querySelectorAll('.c-generic-hero--has-video');

	if (videos.length > 0) {
		videos.forEach((e) => {
			const el = e.querySelector('.c-generic-hero__video');
			const button = e.querySelector('.c-generic-hero__video-toggle');
			const buttonLabel = button.querySelector('.c-generic-hero__video-toggle-label');
			const video = new Video(el, button);
			video.init();

			if (button) {
				// if mobile
				if (!navigator.userAgent.match(/Mobi/)) {
					button.classList.add('playing');
					button.setAttribute('aria-pressed', true);
					buttonLabel.textContent = VIDEO_LABELS.PAUSE;
				}

				button.addEventListener('click', () => {
					if (button.classList.contains('playing')) {
						button.classList.remove('playing');
						button.setAttribute('aria-pressed', false);
						buttonLabel.textContent = VIDEO_LABELS.PLAY;
					} else {
						button.classList.add('playing');
						button.setAttribute('aria-pressed', true);
						buttonLabel.textContent = VIDEO_LABELS.PAUSE;
					}

					video.togglePlay();
				});
			}
		});
	}
}

export default initialiseVideos;
